// extracted by mini-css-extract-plugin
module.exports = {"container":"Time_container__2wxPr","current_time":"Time_current_time__3IXMT","duration":"Time_duration__3ucdk"};